export const $ = (s) => document.querySelector(s);
export const esc = (s) => String(s ?? "");
export const money = (n) =>
  "₹" +
  Number(n || 0).toLocaleString("en-IN", {
    maximumFractionDigits: 2,
  });
export const num = (n) => (n === "" ? null : Number(n));
export const size = (s) => `${s.qty ?? "—"} ${s.unit || ""}`;
export const initials = (name) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0])
    .join("")
    .toUpperCase();
